import { QLEDocument } from "./document";

export class MyQLERequestModel {
    id: number;
    adminEventID: number;
    displayStatusDescription: string;
    displayStatus: number;
    adminEventOptionDescription: string;
    enrollAdminEventOptionID: number;
    eventDate: string;
    dateOfRequest: string;
    expiresOn: string;
    canBeginEnrollment: boolean;
    canEdit: boolean;
    canCancel: boolean;
    canDeleteDocs: boolean;
    canDoAction: boolean;
    noteInformationText: string;
    isDraft: boolean;
    myQLERequestDocuments: QLEDocument[];
    
    constructor() {
        this.id = 0;
        this.adminEventID = 0;
        this.displayStatusDescription = null;
        this.displayStatus = 0;
        this.adminEventOptionDescription = null;
        this.enrollAdminEventOptionID = 0;
        this.eventDate = null;
        this.dateOfRequest = null;
        this.expiresOn = null;
        this.canBeginEnrollment = false;
        this.canEdit = false;
        this.canCancel = false;
        this.canDeleteDocs = false;
        this.canDoAction = false;
        this.noteInformationText = null;
        this.isDraft = false;
        this.myQLERequestDocuments = new Array<QLEDocument>();
    }
}

export class MyQLEAdminEventModel {
    adminEventOptions: AdminEventOption[];
}

export class AdminEventOption {
    id: number;
    value: string;
    description: string;
}

export class MyQLERequestCriteria {
    id: number;
    eventDate: string;
    enrollAdminEventOptionID: number;
    constructor() {
        this.id = 0;
        this.eventDate = null;
        this.enrollAdminEventOptionID = 0;
    }
}
/**
 * MyQLEIDPayload
 * MyQleDocumentDeleteCriteria
 * Combined models since they only pass id
 */
export class MyQLEIDPayload {
    id: number;
}

export class MyQLEChatRequestModel {
    qLERequestID: number;
    chat: string;
}

export class MyQLEChatResponseModel {
    chatEntries: MyQLEChat[];
}

export class MyQLEChat {
    id: number;
    createdBy: string;
    createdOn: string;
    chat: string;
}

